import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card,Box, CardContent, Typography, Grid, CardActionArea } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faUserShield, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import {jwtDecode }from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/constants'; // Ensure this path is correct
import BackButton from '../../components/BackButton';

// Define the card data as a constant
const cardData = [
  {
    title: 'Pincodes',
    icon: faMapMarkerAlt,
    path: 'pincodes',
    modules: [1210,  1211],
  },
  {
    title: 'Admins',
    icon: faUserShield,
    path: 'admins',
    modules: [1310, 1311,1312,1313],
  },
   {
    title: 'Set Commission %',
    icon: faFileAlt,
    path: 'set-divisions',
    modules: [2010],
  },
  // {
  //   title: 'Report',
  //   icon: faFileAlt,
  //   path: 'report',
  //   modules: [1410],
  // },
  // Add more cards as needed
];

const AdminControlManagement = () => {
  const [userLevel, setUserLevel] = useState(null);
  const [userModules, setUserModules] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Decode the JWT and store the user level and userId
    const token = sessionStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserLevel(decodedToken.level);

      if (decodedToken.level === 1 ) {
        // If user is SuperAdmin or Admin, grant access to all modules
        setUserModules(cardData.flatMap(card => card.modules));
      } else {
        // Otherwise, fetch the modules from the privileges stored in the backend
        fetchUserPrivileges(decodedToken.userId);
      }
    }
  }, []);

  const fetchUserPrivileges = async (userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/privileges/modules/${userId}`);
      if (response.status === 200 && response.data.modules) {
        setUserModules(response.data.modules);
      } else {
        console.error('Failed to fetch user privileges or no modules found');
      }
    } catch (error) {
      console.error('Error fetching user privileges:', error);
    }
  };

  // Handler for card click
  const handleCardClick = (path) => {
    navigate(path);
  };

  // Function to check if the user has access to a specific module
  const hasAccess = (modules) => {
    return modules.some(moduleId => userModules.includes(moduleId));
  };

  return (
    <Box sx={{ position: 'relative', padding: 2 }}>
    {/* Place BackButton outside the Grid */}
    <BackButton />
    <Grid container spacing={3} justifyContent="center" alignItems="center">
     
      {cardData.map((card) => (
        hasAccess(card.modules) && (
          <Grid item xs={12} sm={6} md={4} key={card.title}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 225,
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '& .MuiTypography-root': {
                    color: 'white !important',
                  },
                  '& .fa-icon': {
                    color: 'white !important',
                  },
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(card.path)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={card.icon}
                    size="5x"
                    className="fa-icon"
                    style={{ color: 'orange' }}
                  />
                  <Typography gutterBottom variant="h5" component="div" sx={{ marginTop: 2 }}>
                    {card.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )
      ))}
    </Grid>
    </Box>
  );
};

export default AdminControlManagement;
